import { ScheduleGateway } from "../domain/schedule.gateway";

export class CancelUseCase {
    constructor(private gate: ScheduleGateway) {}

    async execute(id: string, text: string): Promise<boolean> {
        return this.gate.cancel(id, text);
    }
}
